import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "chevron", "input"]

  toggle() {
    const isHidden = this.contentTarget.classList.contains("hidden")

    if (isHidden) {
      this.contentTarget.classList.remove("hidden")
      this.chevronTarget.classList.add("rotate-180")
    } else {
      this.contentTarget.classList.add("hidden")
      this.chevronTarget.classList.remove("rotate-180")
    }
  }

  updateSize() {
    const sqft = parseInt(this.inputTarget.value, 10)

    if (sqft && sqft >= 100 && sqft <= 5000) {
      // Update the area display in the mapbox-map controller
      const areaElement = document.querySelector('[data-mapbox-map-target="area"]')
      if (areaElement) {
        areaElement.textContent = sqft
      }

      // Update gallons estimate (sqft × 37.4)
      const gallonsElement = document.querySelector('[data-mapbox-map-target="gallons"]')
      if (gallonsElement) {
        const gallons = Math.round(sqft * 37.4)
        gallonsElement.textContent = gallons.toLocaleString()
      }

      // Enable the continue button
      const continueBtn = document.getElementById('visible-continue-btn')
      if (continueBtn) {
        continueBtn.disabled = false
      }

      // Also enable the hidden submit button
      const hiddenBtn = document.querySelector('[data-mapbox-map-target="continueBtn"]')
      if (hiddenBtn) {
        hiddenBtn.disabled = false
      }
    }
  }
}
